// extracted by mini-css-extract-plugin
export default {"root":"CustomerPrimaryContactCard_root__6YDXH"};